"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _withdrawPlan = _interopRequireDefault(require("../setting/_withdrawPlan"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    withdrawPlan: _withdrawPlan.default
  },
  data: function data() {
    return {
      device: 1,
      fee_plan: {},
      business_mode: {},
      card: {},
      form: {
        agent_withdraw_type: [],
        agent_withdraw_plan: [],
        merchant_withdraw_plan: []
      },
      form_key: {
        agent_withdraw_min_yuan: '',
        agent_withdraw_max_yuan: '',
        merchant_withdraw_min_yuan: '',
        merchant_withdraw_max_yuan: ''
      },
      son_id: this.$route.query.son_id
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      var deviceNameObj = JSON.parse(JSON.stringify(this.$store.state.user.deviceNameObj));
      return deviceNameObj;
    }
  },
  mounted: function mounted() {
    this.setInfo();
  },
  methods: {
    /**
     * 获取信息
     */
    setInfo: function setInfo() {
      var _this = this;
      this.$get('agentapi/sttuf/get_agent_rentting_fee_plan', {
        son_id: this.son_id
      }).then(function (res) {
        var goods_key = _this.config.goods_key,
          fee_xcx = _this.config.fee_xcx,
          fee_plan = {};
        for (var i in goods_key) {
          if (res[goods_key[i] + '_fee_plan']) {
            fee_plan[goods_key[i] + '_fee_plan'] = res[goods_key[i] + '_fee_plan'];
          }
          var goods_key_fee = fee_xcx[goods_key[i]] || fee_xcx.default;
          for (var key in goods_key_fee) {
            if (res["".concat(goods_key[i], "_fund_fee_plan").concat(key)]) {
              fee_plan["".concat(goods_key[i], "_fund_fee_plan").concat(key)] = res["".concat(goods_key[i], "_fund_fee_plan").concat(key)];
            }
            if (res["".concat(goods_key[i], "_fee_plan").concat(key)]) {
              fee_plan["".concat(goods_key[i], "_fee_plan").concat(key)] = res["".concat(goods_key[i], "_fee_plan").concat(key)];
            }
          }
        }
        console.log(fee_plan);
        _this.fee_plan = fee_plan;
        _this.business_mode = res.business_mode;
        var plan = [{
            week_day: 0,
            month_day: 1,
            begin: '00:00',
            end: '24:00'
          }],
          params = {
            son_id: _this.son_id,
            agent_withdraw_date_type: 0,
            agent_withdraw_plan: plan,
            merchant_withdraw_date_type: 0,
            merchant_withdraw_plan: plan
          };
        for (var i in _this.form_key) {
          params[i] = res[i];
        }
        if (res.withdraw_plan && res.withdraw_plan.agent) {
          if (res.withdraw_plan.agent.plan.length > 0) {
            params.agent_withdraw_plan = res.withdraw_plan.agent.plan;
          }
          params.agent_withdraw_date_type = res.withdraw_plan.agent.date_type;
        }
        if (res.withdraw_plan && res.withdraw_plan.merchant) {
          if (res.withdraw_plan.merchant.plan.length > 0) {
            params.merchant_withdraw_plan = res.withdraw_plan.merchant.plan;
          }
          params.merchant_withdraw_date_type = res.withdraw_plan.merchant.date_type;
        }
        _this.form = params;
      });
    },
    /**
     * 输入最大功率
     */
    setPowerMax: function setPowerMax(item) {
      var n = parseInt(item.value) + 1;
      this.fee_plan.zhuang_fee_plan.plan[n].rent_zhuang_unit_power_min = parseInt(item.rent_zhuang_unit_power_max) + 1;
    },
    onSubmit: function onSubmit(device) {
      var _this2 = this;
      var params = {},
        url = 'agentapi/sttuf/save_agent_rentting_fee_plan',
        fee_plan = JSON.parse(JSON.stringify(this.fee_plan)),
        goods_key = this.config.goods_key,
        fee_xcx = this.config.fee_xcx;
      if (this.business_mode["std_".concat(this.config.goods_key[device])]) {
        var stc = this.business_mode["std_".concat(this.config.goods_key[device])];
        params = Object.assign(stc, params);
      }
      var goods_key_fee = fee_xcx[goods_key[device]] || fee_xcx.default;
      for (var key in goods_key_fee) {
        if (fee_plan["".concat(goods_key[device], "_fund_fee_plan").concat(key)]) {
          params["".concat(goods_key[device], "_fund_fee_plan").concat(key)] = fee_plan["".concat(goods_key[device], "_fund_fee_plan").concat(key)];
        }
        if (fee_plan["".concat(goods_key[device], "_fee_plan").concat(key)]) {
          params["".concat(goods_key[device], "_fee_plan").concat(key)] = fee_plan["".concat(goods_key[device], "_fee_plan").concat(key)];
        }
        if (key && this.business_mode["std_".concat(goods_key[device]).concat(key)]) {
          params["".concat(goods_key[device], "_business_mode").concat(key)] = this.business_mode["std_".concat(goods_key[device]).concat(key)];
        }
      }
      params.son_id = this.son_id;
      if (this.form.store_fee_plan_reset) params.store_fee_plan_reset = this.form.store_fee_plan_reset;
      this.$post(url, params).then(function (res) {
        _this2.$post('agentapi/sttuf/save_agent_business_setting', _this2.form).then(function (res) {
          _this2.$message({
            message: '提交成功',
            type: 'success'
          });
          _this2.$store.dispatch('user/getPlatformConfig');
        });
      });
    }
  }
};